/** Extract every <loc>…</loc> from a raw sitemap XML string. */
export const parseUrlsFromSitemapXml = (xml: string): string[] => {
    const doc = new DOMParser().parseFromString(xml, 'text/xml');
    return Array.from(doc.getElementsByTagName('loc'))
        .map((n) => n.textContent?.trim() || '')
        .filter(Boolean);
};
